<div style="width: 100%;">
    <div class="wrapper">

        <div [ngClass]="isStep ? 'step-header' : 'header'">
            <h2>{{ task.isStep ? 'Step ' + task.stepIndex + ':
                ' : ''}}{{ task.typeStr }}</h2>
            <div class="control-buttons" *ngIf="!isStep">
                <app-task-view [task]="task" [showCheckStatus]="false" [showRecalculateButton]="true"
                    [showStatus]="false" [showReindexButton]="true" [showTaskTabButton]="false"
                    [showClearThreadsButton]="task.hasActiveThreads" (deleteProcess)="deleteProcess($event)">
                </app-task-view>
            </div>
        </div>

        <h2 *ngIf="!isStep && task['name'] !== undefined">Name: {{task.name}}</h2>

        <div class="stats mat-typography" *ngIf="!hasSpecificComponents">
            <h3 class="md-subhead">{{task.hasSteps ? 'Summary:' : 'Statistic:'}}</h3>
            <app-process-status-row [process]="task"></app-process-status-row>
            <app-process-statistic-section [process]="task"></app-process-statistic-section>
            <app-process-stats-by-status-section [process]="task"></app-process-stats-by-status-section>
            <app-process-messages-section [process]="task"></app-process-messages-section>
            <div *ngIf="showSaveRawIds" class="mat-typography">
                <p>Save PR Ids for investigation: {{task?.saveRawIds?'Yes':'No'}}
                </p>
            </div>

            <div *ngIf="task['recalculateAllPRs'] !== undefined" class="mat-typography">
                <p>Recalculate all listed Property Records: {{task?.recalculateAllPRs?'Yes':'No'}}
                </p>
            </div>
            <div *ngIf="task['prsWithAddedZCConflictsCount'] !== undefined" class="mat-typography"
                [ngClass]="{'red-text': task.prsWithAddedZCConflictsCount > 0}">
                <p>PRs count with multiple new markets: {{task?.prsWithAddedZCConflictsCount}}
                </p>
            </div>
            <div *ngIf="task['prsGroupIdsWithAddedZCConflicts'] !== undefined" class="mat-typography"
                [ngClass]="{'red-text': task.prsGroupIdsWithAddedZCConflicts.length > 0}">
                <p>PRs with multiple new markets: {{task?.prsGroupIdsWithAddedZCConflicts.join(', ')}}
                </p>
            </div>

            <app-data-source-category-view *ngIf="showDataSourceCategories"
                [dataSourceCategories]="task.dataSourceCategories"></app-data-source-category-view>
        </div>

        <div *ngIf="task.isCalcPRMultiThread">
            <app-process-statistic-selection-calc-pr-multi-thread
                [process]="task"></app-process-statistic-selection-calc-pr-multi-thread>
        </div>

        <div *ngIf="task.isRemoveZoningCodeJob">
            <app-remove-zc-job-process-details-view [process]="task"
                [hideHeaders]="true"></app-remove-zc-job-process-details-view>
        </div>

        <div *ngIf="task['syncSolrData'] !== undefined" style="margin-top: 15px;">
            <p>Send data to Solr: {{task?.syncSolrData?'Yes':'No'}}
            </p>
        </div>

        <div *ngIf="isStep && task?.solrGroupIdsStatistic">
            <h3 class="md-subhead">Synchronization with Solr - <app-solr-operations-status
                    [data]="task?.solrGroupIdsStatistic"></app-solr-operations-status></h3>
            <app-solr-group-ids-data-statistic [data]="task?.solrGroupIdsStatistic">
            </app-solr-group-ids-data-statistic>
        </div>

        <div *ngIf="isStep && task?.isIndexing">
            <div>
                <h3 class="md-subhead">Create</h3>
                <app-bulk-operation-statistic [data]="task?.indexationStatistic?.create"></app-bulk-operation-statistic>
                <h3 class="md-subhead">Update</h3>
                <app-bulk-operation-statistic [data]="task?.indexationStatistic?.update"></app-bulk-operation-statistic>
            </div>
        </div>

        <mat-tab-group *ngIf="!isStep" class="mat-elevation-z0" #tabs (selectedTabChange)="tabChanged($event)"
            mat-stretch-tabs="false">
            <mat-tab label="Steps" *ngIf="task?.steps">
                <app-job-process-details-view *ngFor="let step of task.steps" [task]="step" [isStep]="true">
                </app-job-process-details-view>
            </mat-tab>

            <mat-tab *ngIf="task?.solrGroupIdsStatistic" label="Statistic">
                <div style="padding: 10px;">
                    <h3 class="md-subhead">Synchronization with Solr - <app-solr-operations-status
                            [data]="task?.solrGroupIdsStatistic"></app-solr-operations-status></h3>
                    <app-solr-group-ids-data-statistic [data]="task?.solrGroupIdsStatistic">
                    </app-solr-group-ids-data-statistic>
                </div>
            </mat-tab>

            <mat-tab label="Events">
                <div class="chart-tool-bar">
                    <app-events-stat-component [statistic]="task?.eventsStat" [stateEnv]="task?.state"
                        [hideRefreshButton]="true" style="width: 100%;"></app-events-stat-component>
                    <app-update-system-events-list-button class="inline-action-button" [stateEnv]="task?.state"
                        [parentId]="task?.id" [parentType]="systemEventParentType.PROCESS"
                        [updateDataHandler]="updateEventsList.bind(this)"></app-update-system-events-list-button>
                </div>
                <app-process-events-list [eventsList]="eventsList"></app-process-events-list>
            </mat-tab>

            <mat-tab label="Items List"><app-paginated-process-task-items-list [showPaginatorOnTop]="true"
                    [processId]="task?.id" [stateEnv]="task?.state"></app-paginated-process-task-items-list></mat-tab>
        </mat-tab-group>
    </div>
</div>